import Loader from '@/views/components/Loader.vue'; 

const LoaderPlugin = {
  install(Vue) {
    Vue.component('Loader', Loader);
  },
};

export default LoaderPlugin;